import { render, staticRenderFns } from "./DataCamList.vue?vue&type=template&id=715398bf&"
import script from "./DataCamList.vue?vue&type=script&lang=js&"
export * from "./DataCamList.vue?vue&type=script&lang=js&"
import style0 from "./DataCamList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports